export default "__VITE_ASSET__CL8jnBan__"